import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { ShieldCheck, Lock, Check, ArrowRight } from "lucide-react";

export default function Security() {
  const security = useContent().security;
  return (
    <section id="sicherheit" className="py-20 lg:py-28 bg-[#faf8f4]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mx-auto text-center reveal">
          <div className="eyebrow mb-4">{security.eyebrow}</div>
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold">{security.title}</h2>
          <p className="mt-4 text-[#5c6577] text-lg">{security.text}</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-7 mt-14">
          {security.layers.map((l, i) => (
            <div key={l.level} className="card-lift bg-white rounded-2xl border border-[#efe9dd] p-8">
              <div className="flex items-center justify-between mb-6">
                <span className="inline-flex items-center gap-2 rounded-full bg-[#faf3e8] px-3 py-1 text-xs font-semibold text-[#8f6f3f] tracking-wide">
                  {i === 0 ? <ShieldCheck size={14} /> : <Lock size={14} />} {l.level}
                </span>
                <div className="text-right">
                  <div className="font-serif-lux text-2xl text-[#16233d] leading-none">{l.badge}</div>
                  <div className="text-[11px] text-[#8a8f9c] mt-1">{l.badgeSub}</div>
                </div>
              </div>
              <h3 className="font-serif-lux text-2xl text-[#16233d] mb-3">{l.title}</h3>
              <p className="text-[#5c6577] text-sm leading-relaxed">{l.text}</p>

              {l.bullets && (
                <ul className="mt-5 space-y-2.5">
                  {l.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2.5 text-sm text-[#3a4258]">
                      <Check size={17} className="text-[#b08d57] mt-0.5 shrink-0" /> {b}
                    </li>
                  ))}
                </ul>
              )}
              {l.note && <p className="mt-5 text-xs text-[#8a8f9c] border-t border-[#f0ece3] pt-4">{l.note}</p>}
              {l.link && (
                <a href="#sicherheit" className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-[#b08d57] hover:text-[#8f6f3f] transition-colors">
                  {l.link} <ArrowRight size={15} />
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
